/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GridView, Griew, Column, Response, Filter } from "react-griew";
import BankAccountService from "../../service/bank-account-service";
import Pasoonate from "pasoonate";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import CreatePartyBankAccountWindow from "./CreatePartyBankAccountWindow";
import EditPartyBankAccountWindow from "./EditPartyBankAccountWindow";

const bankAccountService = new BankAccountService();

await loadDictionary('bank-account-party-section');

const griew = new Griew();

function PartyBankAccountMainPage() {
  const [count, setCount] = useState(0);
  const [openCreateWindow, setOpenCreateWindow] = useState(false);
  const [openEditWindow, setOpenEditWindow] = useState(false);
  const [editBankAccountId, setEditBankAccountId] = useState(null);
  const [removeBankAccountId, setRemoveBankAccountId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const reloadList = () => { 
    setIsLoading(true);

    griew.filters.add('party_id', Column.NUMBER, Filter.IS_NOT_EQUAL_TO, null, null);
    griew.refresh();
  };
  const remove = (id) => {
    bankAccountService.findOne(id).then(bankAccount => {
      if(bankAccount && confirm(i18n.t("bank-account-party-section.remove_alert"))) {
        bankAccountService.remove(bankAccount).then(result => {
          if(result) {
            reloadList();
          }
        }).catch(error => {
          console.error(error);
        });
      }
    });    
  }

  useEffect(() => {
    prepareGriew(setCount, setEditBankAccountId, setRemoveBankAccountId, setIsLoading);

    reloadList();
  }, []);

  useEffect(() => {
    if(editBankAccountId) {
      setOpenEditWindow(true);
      setEditBankAccountId(null);
    }
  }, [editBankAccountId]);

  useEffect(() => {
    if(removeBankAccountId) {
      remove(removeBankAccountId);
      setRemoveBankAccountId(null);
    }
  }, [removeBankAccountId]);

  return (
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("bank-account-party-section.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className="btn btn-sm btn-primary me-2 mb-2" type="button" onClick={() => {setOpenCreateWindow(true)}}>{i18n.t("bank-account-party-section.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
        <CreatePartyBankAccountWindow openWindow={openCreateWindow} setOpenWindow={setOpenCreateWindow}></CreatePartyBankAccountWindow>
        <EditPartyBankAccountWindow openWindow={openEditWindow} setOpenWindow={setOpenEditWindow} editBankAccountId={editBankAccountId}></EditPartyBankAccountWindow>
      </div>
  );
}

function prepareGriew(setCount, setEditBankAccountId, setRemoveBankAccountId, setIsLoading) {
  const list = [
    {
      name: "id",
      caption: "کد",
      schema: "BankAccount",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "party_id",
      caption: "شناسه طرف حساب",
      schema: "BankAccount",
      type: Column.NUMBER,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: false
    },
    {
      name: "party_name",
      caption: "طرف حساب",
      schema: "Party",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: false,
      beforeRender: (value, bankAccount) => {
        return bankAccount?.party?.name;
      }
    },
    {
      name: "name",
      caption: "نام حساب",
      schema: "BankAccount",
      type: Column.STRING,
      order: 3,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "bank_name",
      caption: "نام بانک",
      schema: "Bank",
      type: Column.STRING,
      order: 4,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, bankAccount) => {
        return bankAccount?.bank?.name;
      }
    },
    {
      name: "account_number",
      caption: "شماره حساب",
      schema: "BankAccount",
      type: Column.STRING,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "iban",
      caption: "شماره شبا",
      schema: "BankAccount",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "card_number",
      caption: "شماره کارت",
      schema: "BankAccount",
      type: Column.STRING,
      order: 7,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "created_at",
      caption: "تاریخ ایجاد",
      schema: "BankAccount",
      type: Column.DATETIME,
      order: 8,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "updated_at",
      caption: "تاریخ ویرایش",
      schema: "Party",
      type: Column.DATETIME,
      order: 9,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{updatedAt}</span>;
      },
    },
    {
      name: "",
      caption: "عملیات",
      schema: "",
      type: Column.STRING,
      order: 10,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, bankAccount) => { 
        const editButton = bankAccount.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light" onClick={() => { setEditBankAccountId(bankAccount.id) }}>{i18n.t("bank-account-party-section.edit_button")}</button>;
        const removeButton = bankAccount.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { setRemoveBankAccountId(bankAccount.id) }}>{i18n.t("bank-account-party-section.remove_button")}</button>;

        return (
          <>
          {editButton}          
          {removeButton}
          </>
        );
      }
    }
  ];
  
  const callback = function (promis) {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };
    
  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
    function: (query) => bankAccountService.gridview(query),
    callback: callback
  };
}

export default PartyBankAccountMainPage;